import React from 'react';
import Animation from '../Animation';
import loader from './loader.json';

const Loader = props => <Animation data={loader} {...props} />;

export default Loader;
